export default "__VITE_ASSET__e7e2b747__"